/*@flow*/
import type { Node } from 'react';
import React, { useContext } from 'react';
import { StackContext } from './contexts';
import compose from 'lib/compose';
import Panel from './Panel';
import type { DotTypeT, DotStyleT } from 'comps/Dot';

const is = (name) => (v) => v.type === name;
const has = (key) => (v) => v[key];
const filter = (pred) => (v) => v.filter(pred);
const getOwn = compose(
  filter(is('category')),
  filter(has('colorDomain'))
);

export type CategoryT = {
  colorDomain: string[],
  colorRange: string[],
  prefaceItems: {
    dotStyle: DotStyleT,
    dotType: DotTypeT,
    color: string,
    label: string,
    category_type: string,
    uuid: string,
  }[],
  dotStyle?: DotStyleT,
  dotType?: DotTypeT,
  type: string,
  title: string,
  category_type: string,
  uuid: string,
};

// Category Panels
// -------------------
//
// {
//   type: 'category',
//   title: 'Foo',
//   colorDomain: ['Beverage 1'],
//   colorRange: ['#C0FFEE'],
//   dotStyle: 'fill',
//   dotType: 'circle'
// }

const Component = ({
  setInternalUpdate,
  internalUpdate,
  filters,
}: {
  setInternalUpdate: Function,
  internalUpdate: any,
  filters: any,
}): null | Array<Node> | Array<any> => {
  const legends = useContext(StackContext);
  const ownLegends = getOwn(legends);
  if (ownLegends.isEmpty()) return null;
  let ol = ownLegends.toJS();
  if (!Array.isArray(ol)) return ([]: any[]);
  ol = ((ol: any): CategoryT[]);
  return ol.map<*, *>((v, j) => {
    const items = v.colorDomain.map((v2, i) => ({
      color: v.colorRange[i] || 'black',
      label: v2,
      dotType: v.dotType || 'circle',
      dotStyle: v.dotStyle || 'stroke',
      category_type: '',
      uuid: '',
    }));

    return (
      <Panel
        type="category"
        uuid={v.uuid}
        category_type={v.category_type}
        title={v.title}
        key={j}
        items={items}
        prefaceItems={v.prefaceItems}
        internalUpdate={internalUpdate}
        setInternalUpdate={setInternalUpdate}
        historyFilters={filters}
      />
    );
  });
};
export default Component;
